<footer *ngIf="siteProfile== 'superefectivo'" class="footer">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-md-2 col-4 order-lg-0 order-md-0 order-2">
                <a href="{{links.home}}">
                    <img src="/assets/logo.png" alt="Logo Superefectivo" class="img-fluid">
                </a>
            </div>
            <div class="col-md-10 col-8 d-none d-lg-block d-md-block">
                <div class="row">
                    <div class="col-md-12 p-0">
                        <nav class="nav justify-content-center">
                            <a href="{{links.faq}}">
                                Preguntas frecuentes
                            </a>
                            <a href="{{links.legal}}">
                                Aviso legal
                            </a>
                            <a href="{{links.privacy_policy}}">
                                Política de privacidad
                            </a>
                            <a href="{{links.cookie_policy}}">
                                Política de cookies
                            </a>
                            <a href="{{links.claims_policy}}">
                                Política de reclamaciones
                            </a>
                        </nav>
                    </div>
                    <div class="col-md-12">
                        <p class="d-flex align-items-center justify-content-center credits"><span>&copy; </span> {{currentYear}} {{credits}}</p>
                    </div>
                </div>
            </div>
            <div class="col-4 d-block d-lg-none d-md-none order-lg-0 order-md-0 order-1">
                <nav class="nav justify-content-center">
                    <a href="/preguntas-frecuentes">
                        Preguntas frecuentes
                    </a>
                    <a href="/aviso-legal">
                        Aviso legal
                    </a>
                    <a href="/politica-de-privacidad">
                        Política de privacidad
                    </a>
                    <a href="/politica-de-cookies">
                        Política de cookies
                    </a>
                    <a href="/politica-de-reclamaciones">
                        Política de reclamaciones
                    </a>
                </nav>
            </div>
            <div class="col-4 d-block d-lg-none d-md-none order-lg-0 order-md-0 order-3 credits">
                <p class="text-left">{{currentYear}} {{credits}}</p>
            </div>
        </div>
    </div>
</footer>
<footer *ngIf="siteProfile== 'orocaja'" class="footer">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="">
                <a href="/">
                    <img src="/assets/logo.png" alt="Logo Superefectivo" class="img-fluid">
                </a>
            </div>


            <div class=" credits">
                <p class="text-left">{{currentYear}} {{credits}}</p>
            </div>
        </div>
    </div>
</footer>